
import Loader from "./index";
export default Loader;
